<div class="header-tabs">
  <div class="header-tabs__title">{{ routePrefix + '.title' | translate }}</div>
  <div class="header-tabs__content">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel">
      @for (tab of tabs; track tab.route) {
        <a
          mat-tab-link
          routerLinkActive="mdc-tab--active"
          [routerLink]="tab.route"
          (click)="tab.route === appRoutes.SUBSCRIPTION ? onSubscriptionTabClick($event) : null"
        >
          {{ tab.label | translate }}
        </a>
      }
    </nav>
    <mat-tab-nav-panel #tabPanel>
      <router-outlet />
    </mat-tab-nav-panel>
  </div>
</div>
